import React from "react";
import { Field, reduxForm } from "redux-form";

import { required } from "../../../../common/validators";
import ReactMDTextField from "../../../../common/components/ReactMDTextField";
import { Button, CardActions, FontIcon } from "react-md";
import ReactMDSelectField
  from "../../../../common/components/ReactMDSelectField";
import { months, days, minorYears as years } from "../../../../common/utils";
import FormInputIcon from "../../../../common/components/FormInputIcon";

const MinorInfoForm = ({ handleSubmit, invalid, submitting, index }) => (
  <div>
    <section className="md-grid">
      <Field
        validate={[required]}
        id={`minors/${index}.firstName`}
        name={`minors/${index}.firstName`}
        component={ReactMDTextField}
        label="First Name"
        leftIcon={<FontIcon>face</FontIcon>}
        className="md-cell md-cell--6"
        required
      />
      <Field
        validate={[required]}
        id={`minors/${index}.lastName`}
        name={`minors/${index}.lastName`}
        component={ReactMDTextField}
        label="Last Name"
        className="md-cell md-cell--6"
        required
      />
      <Field
        validate={[required]}
        id={`minors/${index}.phone`}
        name={`minors/${index}.phone`}
        type="number"
        component={ReactMDTextField}
        label="Phone Number"
        className="md-cell md-cell--12"
        required
        leftIcon={<FontIcon>phone</FontIcon>}
      />
      <FormInputIcon>perm_contact_calendar</FormInputIcon>
      <Field
        label="Month"
        placeholder="Select Month"
        className="md-cell md-cell--4 md-cell--with-icon"
        helpText="Date of Birth"
        menuItems={months}
        itemLabel="label"
        itemValue="value"
        id={`minors/${index}.dateOfBirth.month`}
        name={`minors/${index}.dateOfBirth.month`}
        required
        component={ReactMDSelectField}
        validate={[required]}
      />
      <Field
        label="Day"
        placeholder="Select Day"
        className="md-cell md-cell--4"
        menuItems={days}
        itemLabel="label"
        itemValue="value"
        id={`minors/${index}.dateOfBirth.day`}
        name={`minors/${index}.dateOfBirth.day`}
        required
        component={ReactMDSelectField}
        validate={[required]}
      />
      <Field
        label="Year"
        placeholder="Select Year"
        className="md-cell md-cell--4"
        menuItems={years}
        id={`minors/${index}.dateOfBirth.year`}
        name={`minors/${index}.dateOfBirth.year`}
        required
        component={ReactMDSelectField}
        validate={[required]}
      />
    </section>
    <CardActions>
      <Button
        raised
        label="Save & Continue"
        primary
        className="md-cell--right"
        disabled={submitting || invalid}
        onClick={handleSubmit}
      />
    </CardActions>
  </div>
);

MinorInfoForm.propTypes = {};
MinorInfoForm.defaultProps = {};

export default reduxForm({
  form: "minor-info-form"
})(MinorInfoForm);



// WEBPACK FOOTER //
// ./src/registration/components/Minors/MinorInfo/MinorInfoForm.jsx